var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { light: "", persistent: "", fullscreen: "" },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c("v-card", [
            _c(
              "div",
              {
                staticClass: "thisDialog text-center",
                staticStyle: { height: "100vh" },
              },
              [
                _c("div", { staticClass: "superCenter" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "max-width": "305px",
                          display: "inline-block",
                        },
                      },
                      [
                        _c("h2", [_vm._v(_vm._s(_vm.codeTitle))]),
                        _vm.codeSubtitle
                          ? _c("h4", [_vm._v(_vm._s(_vm.codeSubtitle))])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "mt-6" },
                          [
                            _vm.$store.getters.isAndroidKiosk
                              ? _c("v-text-field", {
                                  staticClass: "roundInput",
                                  attrs: {
                                    readonly: "",
                                    inputmode: "none",
                                    "input-props": { inputmode: "none" },
                                    autofocus: "",
                                    "prepend-inner-icon": "mdi-lock",
                                    outlined: "",
                                    label: "Enter your code",
                                    required: "",
                                    "full-width": "",
                                    clearable: "",
                                  },
                                  on: { focus: _vm.codeFocus },
                                  model: {
                                    value: _vm.theCode,
                                    callback: function ($$v) {
                                      _vm.theCode = $$v
                                    },
                                    expression: "theCode",
                                  },
                                })
                              : _c("v-text-field", {
                                  staticClass: "roundInput",
                                  attrs: {
                                    "prepend-inner-icon": "mdi-lock",
                                    outlined: "",
                                    autofocus: "",
                                    label: "Enter your code",
                                    required: "",
                                    "full-width": "",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.theCode,
                                    callback: function ($$v) {
                                      _vm.theCode = $$v
                                    },
                                    expression: "theCode",
                                  },
                                }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "text-none btn-df mt-3",
                                attrs: { rounded: "", color: " primary" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    $event.stopPropagation()
                                    return _vm.goAhead("button")
                                  },
                                },
                              },
                              [_vm._v(" Confirm ")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "text-none mt-3",
                                attrs: { rounded: "", color: "primary" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleDismiss.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v(" CANCEL ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm.showPinInput
        ? _c("div", { staticClass: "fixedVirtualKeyboard" }, [
            _c(
              "div",
              { staticClass: "superCenter" },
              [
                _c("VirtualPinInput", {
                  attrs: { label: _vm.pinInputLabel },
                  on: {
                    enter: _vm.pinInputEnter,
                    close: function ($event) {
                      _vm.showPinInput = false
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }